export default {
  buttons: {
    add: "+ Hinzufügen",
    edit_note: "Notiz bearbeiten",
    add_note: "Notiz hinzufügen",
  },
  points: {
    earn_point: "Verdiene {{count}} Punkt",
    earn_point_other: "Verdiene {{count}} Punkte",
  },
  words: {
    optional: "optional",
  },
  note: {
    title: 'Notiz für Küche',
    placeholder: 'Allergien oder besondere Wünsche?',
  },
  error_messages: {
    missing_fields: "Bitte wähle alle erforderlichen Felder aus.",
    product_unavailable: "Ausverkauft!",
  },
};
